// store/news/reducers/update-product-reducer.js
import {
    UPDATE_NEWS_REQUEST,
    UPDATE_NEWS_SUCCESS,
    UPDATE_NEWS_FAILURE,
    RESET_UPDATE_NEWS_STATE
} from '../actions/update-news-actions';

const initialState = {
    loading: false,
    response: null,
    error: null,
};

export default function updateNewsReducer(state = initialState, action) {
    switch (action.type) {
        case UPDATE_NEWS_REQUEST:
            return {...state, loading: true, error: null};
        case UPDATE_NEWS_SUCCESS:
            return {...state, loading: false, response: action.payload};
        case UPDATE_NEWS_FAILURE:
            return {...state, loading: false, error: action.payload};
        case RESET_UPDATE_NEWS_STATE:
            return {
                ...state,
                loading: false,
                response: null,
                error: null
            };
        default:
            return state;
    }
}
